<script>
  import { onMount } from "svelte";
  import Card from "./Card.svelte";
  import { SetupStore } from "../stores/gameStore";
  import {
    getTextsKings,
    getTextsSkills,
    getTextsRestrictions
  } from "../../constants/allTexts";

  export let id, card;

  const textCreature = _('Creature');
  const textIgnore = _('Minimum speed needed to ignore');
  const textsKings = getTextsKings();
  const textsSkills = getTextsSkills();
  const textsRestrictions = getTextsRestrictions();
  const textClass = _('Class');

  onMount(() => {
    const scaleFactor = 0.65;
    const backgroundWidth = 2596 * scaleFactor;
    const backgroundHeight = 3432  * scaleFactor;
    const cardsX = 7; // Width of each card in Amount of Cards
    const cardsY = 6; // Height of each card in Amount of Cards
    let cardWidth = backgroundWidth / cardsX;
    let cardHeigth = backgroundHeight / cardsY;
    window.GAME.addTooltipHtml(
      id,
      `<div style="display:flex; flex-direction:column; margin: 1rem;">
        <div style="width:100%;display:flex;justify-content:space-between;align-items:center; gap:2rem; " >
                ${
                  card.type === "KING"
                    ? `<div class="headline">${textsKings[id].name}</div>`
                    : `<div class="headline">${textCreature}</div>
                      <div 
                        style="
                          background: rgb(0,0,0);
                          color: rgb(256,256,256);
                          box-shadow: 0px 1px 4px 0px rgba(0,0,0,.6);
                          font-weight: bold;
                          border-radius: 10px; /* Rounded corners */
                          padding: 0.2rem 0.6rem; /* Add padding for dynamic sizing */
                          display: inline-flex; /* Inline-flex to size dynamically and center content */
                          justify-content: center;
                          align-items: center;
                        ">
                        <div 
                          style="
                            font-size: 0.8rem;
                            white-space: nowrap; /* Prevent wrapping */
                          ">
                          ${textClass} ${card.level}
                        </div>
                      </div>`
                }
          </div>
          <hr style="width:100%;"/>
          ${
            card.combat.restriction
              ? `
                <div style="display:flex; width:100%; justify-content:center; color:red; font-weight:bold;">${textsRestrictions[card.combat.restriction].name}</div>
                <div style="display:flex; width:100%; justify-content:center;">(${textIgnore}: ${card.level || 4})</div>
                <hr style="width:100%;"/>
                `
              : ""
          }
      
              <div style="display:grid; grid-template-columns:auto 1fr; grid-column-gap:0.5rem">
            ${card.combat.skills.map((c) => `<div>${c.value !== undefined ? c.value + " " : ""}</div><div>${textsSkills[c.type]?.name}</div>`).join("")}
              </div>
          <div 
            style="
              display: flex; 
              justify-content: center;
              margin-top: 1rem;">
            <div 
              <div 
                style="
                  background-image: url('${g_gamethemeurl}img/CardsEnemies.jpg');
                  background-position: -${card.offset[1] * cardWidth}px -${card.offset[0] * cardHeigth}px;
                  width: ${cardWidth}px;
                  height: ${cardHeigth}px;
                  background-size: ${backgroundWidth}px ${backgroundHeight}px;
                  margin-bottom: 1rem;
                  border-radius: 15px;
                  filter: drop-shadow(0 0 0.75rem rgb(0, 0, 0, 0.5));
                ">
            </div>
          </div>      
        </div>`
    );
  });
</script>

<!-- <pre>{JSON.stringify(id, null, 2)}</pre> -->
<Card {id} {card} {...$$props} />
